import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCheckAllocationWarningsRequestPending() {
      return getState().request.isPending;
    },
    isCheckAllocationWarningsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    isCheckAllocationWarningsRequestFailure() {
      return getState().request.isFailure;
    },
    getCheckAllocationWarnings() {
      return getState().warnings;
    },
  };
}

export { createSelector };
